import { createContext, useState, useEffect } from 'react'
import { loadUserAction } from '../reducers/auth/auth'
import { useDispatch } from 'react-redux'
import { getAuthWhs, getBPMasterData, getItemMasterData } from '../reducers/masterData/masterData'

export const ConstContext = createContext()

const ConstContextProvider = ({ children }) => {
	const dispatch = useDispatch()
	const [showToast, setShowToast] = useState({
		show: false,
		message: '',
		type: ''
	})
	const [showItemMasterData, setShowItemMasterData] = useState(false)
	const [collapsed, setCollapsed] = useState(false);
	const [mobileNav, setMobileNav] = useState(false);
	const [isMobile, setisMobile] = useState(false);

	// Post context data
	const constContextData = {
		showToast,
		setShowToast,
		showItemMasterData,
		setShowItemMasterData,
		collapsed,
		setCollapsed,
		mobileNav,
		setMobileNav,
		isMobile, 
		setisMobile
	}

	useEffect(() => {
		dispatch(loadUserAction()).then((res) => {
			if (res.payload.success) {
				console.log(res)
				dispatch(getBPMasterData())
				dispatch(getItemMasterData())
				dispatch(getAuthWhs(res))

			}
		});

	}, [])
	return (
		<ConstContext.Provider value={constContextData}>
			{children}
		</ConstContext.Provider>
	)
}

export default ConstContextProvider